import Backbone from 'backbone';
import template from '../templates/notice.html';

const NoticesView = Backbone.View.extend({
  initialize(options) {
    this.options = options || {};
  },

  events: {
    'click .notifications .close': 'closeAction',
  },

  render() {
    if (this.options.noticeData) {
      this.$el.prepend(template(this.options.noticeData));
    }
  },

  close() {
    this.$el.empty().off();
  },

  closeAction() {
    this.close();
    if (this.options.closeCallback) {
      this.options.closeCallback({
        noticeData: this.options.noticeData,
        delete: true,
      });
    }
  },
});

export default NoticesView;



/** WEBPACK FOOTER **
 ** ./src/views/view.js
 **/